import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SectionLabel } from "./SectionLabel";

export const Breadcrumbs = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" className="mb-8">
    <ol className="flex flex-wrap items-center gap-2 font-mono-ss text-[0.66rem] tracking-wider uppercase text-[#8A9098]">
      <li><Link to="/" className="hover:text-[#1A1C1E]">Home</Link></li>
      {items.map((it, i) => (
        <li key={i} className="flex items-center gap-2">
          <span className="text-[#C8C2B7]">/</span>
          {it.to ? <Link to={it.to} className="hover:text-[#1A1C1E]">{it.label}</Link> : <span className="text-[#1A1C1E]">{it.label}</span>}
        </li>
      ))}
    </ol>
  </nav>
);

/** Inner-page header band that clears the fixed nav. */
export const PageHeader = ({ eyebrow, marker, title, intro, breadcrumbs, children }) => (
  <header className="ss-container pt-32 lg:pt-40 pb-12 lg:pb-16" data-testid="page-header">
    {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
    {eyebrow && <SectionLabel marker={marker} className="mb-7">{eyebrow}</SectionLabel>}
    <motion.h1
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="font-display text-5xl sm:text-6xl lg:text-7xl font-light leading-[0.98] tracking-tight text-[#1A1C1E] max-w-5xl"
    >
      {title}
    </motion.h1>
    {intro && (
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-7 max-w-2xl text-lg sm:text-xl font-light leading-relaxed text-[#52575D]"
      >
        {intro}
      </motion.p>
    )}
    {children}
  </header>
);

export default PageHeader;
